import Rollbar from 'rollbar';
import logger from '@/core/logger/logger';
import type { PlaceApiParameters, Prediction } from './type';
import {Loader} from '@googlemaps/js-api-loader';

export const loadGoogle = async () => {
    const loader = new Loader({
        apiKey: import.meta.env.VITE_GOOGLE_API,
        version: 'weekly',
        libraries: ['places']
    });

    const google = await loader.load();
    return new GooglePlaceApi(google, logger);
}

export interface PlaceApi {
    autocomplete(search: string, parameters: PlaceApiParameters): Promise<Prediction[]>;
}

export class GooglePlaceApi implements PlaceApi {
    private logger: Rollbar;
    private AutocompleteSuggestion: any;

    constructor(google: any, logger: Rollbar) {
        this.logger = logger;
        this.AutocompleteSuggestion = google.maps.places.AutocompleteSuggestion;
    }

    async autocomplete(search: string, parameters: PlaceApiParameters): Promise<Prediction[]> {
        const params = {
            input: search,
            includedRegionCodes: [parameters.country],
            region: parameters.region
        }

        const response = await this.AutocompleteSuggestion.fetchAutocompleteSuggestions(params).catch(() => {
            return {
                suggestions: []
            }
        }) as any;

        const result = [];
        for(const suggestion of response.suggestions) {
            const place = suggestion.placePrediction.toPlace();
            await place.fetchFields({
                fields: ['id', 'formattedAddress', 'addressComponents'],
            });

            result.push({
                description: place.formattedAddress,
                place_id: place.id,
                address_components: place.addressComponents
            });
        }

        return result;
    }
}
